// src/composer/animation.ts

export function applyBob(ctx: CanvasRenderingContext2D, t: number, size: number): void {
  const offsetY = Math.round(Math.sin(t * 1.4) * 0.6);
  if (offsetY === 0) return;
  // Relies on renderBuild having been called this frame to repaint clipped edge rows.
  const img = ctx.getImageData(0, 0, size, size);
  ctx.clearRect(0, 0, size, size);
  ctx.putImageData(img, 0, offsetY);
}

export function applyShimmer(
  ctx: CanvasRenderingContext2D,
  accentLight: string,
  t: number,
  size: number,
): void {
  const ar = parseInt(accentLight.slice(1, 3), 16);
  const ag = parseInt(accentLight.slice(3, 5), 16);
  const ab = parseInt(accentLight.slice(5, 7), 16);
  const img = ctx.getImageData(0, 0, size, size);
  const d = img.data;
  let anyMatch = false;
  // First pass: locate matching pixels. Bail before the (more expensive) sin
  // computation if the palette accent isn't visible on the canvas at all.
  const matches: number[] = [];
  for (let i = 0; i < d.length; i += 4) {
    if (d[i] === ar && d[i+1] === ag && d[i+2] === ab && d[i+3] === 255) {
      matches.push(i);
      anyMatch = true;
    }
  }
  if (!anyMatch) return;
  for (const i of matches) {
    const px = (i >> 2) % size;
    const py = (i >> 2) / size | 0;
    const h = ((px * 7 + py * 13) % 628) / 100;
    const factor = 0.85 + 0.15 * Math.sin(t * 2.5 + h);
    d[i]   = Math.round(d[i]   * factor);
    d[i+1] = Math.round(d[i+1] * factor);
    d[i+2] = Math.round(d[i+2] * factor);
  }
  ctx.putImageData(img, 0, 0);
}
